import formatDate from "dateformat";
import { GetResponseTimelineByCountry_responsesChangeTimelineByCountry_data } from "../../../../../apollo-types/GetResponseTimelineByCountry";

type TimePoint = GetResponseTimelineByCountry_responsesChangeTimelineByCountry_data;
export interface ProcessedTimePoint extends TimePoint {
  startPercent: number;
  endPercent: number;
}

type HashedTimeline = {
  [key: string]: {
    [key: string]: TimePoint[];
  };
};

type ProcessedTimeline = {
  [key: string]: {
    [key: string]: ProcessedTimePoint[];
  };
};

export const getTimePassed = (startDate: string, endDate: string) => {
  return Math.max(
    0,
    new Date(endDate).getTime() - new Date(startDate).getTime()
  );
};

interface ProcessTimelineDataInput {
  startDate: string;
  currentDate: string;
  responseTimeline: GetResponseTimelineByCountry_responsesChangeTimelineByCountry_data[];
}

export const processTimelineData = ({
  startDate,
  currentDate,
  responseTimeline,
}: ProcessTimelineDataInput) => {
  const totalTimePassed = getTimePassed(startDate, currentDate);

  const hashedTimeLine: HashedTimeline = {
    C: {
      "1": [],
      "2": [],
      "3": [],
      "4": [],
      "5": [],
      "6": [],
      "7": [],
      "8": [],
    },
    E: {
      "1": [],
      "2": [],
      "3": [],
      "4": [],
    },
    H: {
      "1": [],
      "2": [],
      "3": [],
      "4": [],
      "5": [],
    },
  };

  responseTimeline.forEach((t) => {
    hashedTimeLine[t.policyType[0]][t.policyType[1]].push(t);
  });

  const processedTimeline: ProcessedTimeline = {
    C: {
      "1": [],
      "2": [],
      "3": [],
      "4": [],
      "5": [],
      "6": [],
      "7": [],
      "8": [],
    },
    E: {
      "1": [],
      "2": [],
      "3": [],
      "4": [],
    },
    H: {
      "1": [],
      "2": [],
      "3": [],
      "4": [],
      "5": [],
    },
  };

  for (const p in hashedTimeLine) {
    const policyTimeline = hashedTimeLine[p];
    for (const pt in policyTimeline) {
      const timelineArray = policyTimeline[pt];
      processedTimeline[p][pt] = timelineArray
        .map((t, index) => {
          const nextEvent = timelineArray[index + 1]?.date;
          const startTime = getTimePassed(startDate, t.date);
          const endTimeTime = getTimePassed(
            startDate,
            nextEvent || currentDate
          );

          return {
            ...t,
            startPercent: startTime / totalTimePassed,
            endPercent: endTimeTime / totalTimePassed,
          };
        })
        .filter((t) => t.startPercent >= 0);
    }
  }

  return processedTimeline;
};

interface GetDatesInput {
  startDate: string;
  currentDate: string;
}

const timeToDateString = (time: number) => {
  return formatDate(new Date(time), "mmm dd");
};

export const getDatePoints = ({ startDate, currentDate }: GetDatesInput) => {
  const totalTimePassed = getTimePassed(startDate, currentDate);
  const oneFifth = Math.round(totalTimePassed / 4);

  const startTime = new Date(startDate).getTime();

  return [
    timeToDateString(startTime),
    timeToDateString(startTime + oneFifth),
    timeToDateString(startTime + oneFifth * 2),
    timeToDateString(startTime + oneFifth * 3),
    formatDate(currentDate, "mmm dd"),
  ];
};
